import Swiper from 'swiper/bundle';

export default class ArticleSliders {

    ready() {

        const WRAPPERS = document.querySelectorAll('.mtt-articles-widget');
        if (WRAPPERS.length > 0) {
            for (let i = 0; i < WRAPPERS.length; i++) {
                new ArticleSlider(WRAPPERS[i]);
            }
        }
    }
}

class ArticleSlider {

    constructor(WRAPPER) {
        this.WRAPPER = WRAPPER;
        this.SLIDES = this.WRAPPER.querySelectorAll('.swiper-slide');
        this.hidden = false;
        
        // create swiper on init
        this.SWIPER = this.createSwiper();
    }

    createSwiper() {

        const PREV = this.WRAPPER.querySelector('.swiper-button-prev');
        const NEXT = this.WRAPPER.querySelector('.swiper-button-next');
        const PROGRESS_BAR = this.WRAPPER.querySelector('.swiper-pagination');

        return new Swiper(this.WRAPPER.querySelector('.swiper-container'), {
            containerModifierClass: 'swiper-container-',
            slidesPerView: 1.1,
            speed: 800,
            spaceBetween: 24,
            freeMode: false,
            watchOverflow: true,
            navigation: {
                addIcons: false,
                nextEl: NEXT,
                prevEl: PREV,
            },
            pagination: {
                el: PROGRESS_BAR,
                type: 'progressbar',
            },
            breakpoints: {
                401: {
                    slidesPerView: 1.2
                },
                551: {
                    slidesPerView: 1.5
                },
                701: {
                    slidesPerView: 2
                },
                901: {
                    slidesPerView: 2.5
                },
                1161: {
                    slidesPerView: 3
                },
                1401: {
                    slidesPerView: 3.3
                }
            }
        });
    }
}
